export const SEARCH_LESSONS_SUB_URL = {
  topicDetails: 'topic-details',
  unitDetails: 'unit-details',
  activitiesDetails: 'activity-details',
};
